export default "__VITE_ASSET__B50jzWz6__"